/**
 * Keys sort criteria by what each level selects, so two criteria that select the same order produce
 * the same key even when they are different objects. Cleared criteria key to "", which no real sort
 * produces because `primary` is required.
 * @example getSortCriteriaKey(dueDateAscThenTitleDesc) === "dueDate:asc,title:desc"
 * @param sort The sort criteria, or null when cleared
 */ export function getSortCriteriaKey(sort) {
    return [
        sort?.primary,
        sort?.secondary,
        sort?.tertiary
    ].filter((level)=>level != null).map((level)=>`${level.field}:${level.isAscending ? "asc" : "desc"}`).join(",");
}
